import { useState, useEffect } from "react";
import api from '../config/api';

export default function EditAccountCodeModal({ show, onClose, onSuccess, selectedCode }) {
  const [accountCodes, setAccountCodes] = useState([]);
  const [form, setForm] = useState({
    name: "",
    code: "",
    description: "",
    parent_id: ""
  });

  useEffect(() => {
    const fetchAccountCodes = async () => {
      const token = localStorage.getItem("token");
      const response = await fetch(api("/account_codes/"), {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      setAccountCodes(data);
    };
    fetchAccountCodes();
  }, []);

  useEffect(() => {
    if (selectedCode) {
      setForm({
        name: selectedCode.name || "",
        code: selectedCode.code || "",
        description: selectedCode.description || "",
        parent_id: selectedCode.parent_id || "",
      });
    }
  }, [selectedCode]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    try {
      const payload = {
        name: form.name,
        code: form.code,
        description: form.description,
        parent_id: form.parent_id ? Number(form.parent_id) : null,
      };

      const res = await fetch(api(`/account_codes/${selectedCode.id}`), {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        alert("Failed to update account code");
        return;
      }

      alert("Account code updated");
      onClose();
      onSuccess();
    } catch (err) {
      console.error(err);
      alert("Error updating account code");
    }
  };

  if (!show) return null;

  return (
    <div className="modal fade show d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <form onSubmit={handleSubmit}>
            <div className="modal-header">
              <h5 className="modal-title">Edit Account Code</h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Parent Account (optional)</label>
                <select
                  className="form-select"
                  name="parent_id"
                  value={form.parent_id}
                  onChange={handleChange}
                >
                  <option value="">-- None --</option>
                  {accountCodes.map((ac) => (
                    <option key={ac.id} value={ac.id}>
                      {ac.code} - {ac.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label">Code</label>
                <input
                  className="form-control"
                  name="code"
                  value={form.code}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Name</label>
                <input
                  className="form-control"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Description</label>
                <input
                  className="form-control"
                  name="description"
                  value={form.description}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-danger text-white" onClick={onClose} type="button">
                Cancel
              </button>
              <button className="btn btn-primary" type="submit">
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
